module.exports = __webpack_public_path__ + "static/p-arin-fdf3004e2ab6f29957a9dd6517dc584f.jpg";